import { StockOptions } from 'results/constants'
import { ListItem } from './interfaces'

export const buildStockFilterOptions = (
  stockItems: StockOptions[],
  isItemActive: (item: string) => boolean,
  displayUserFiltering: string | undefined,
  activeBoolean: boolean
): ListItem[] =>
  stockItems.map((item) => {
    if (
      item === StockOptions.ONLY_PRICED &&
      Number(displayUserFiltering) === 1
    ) {
      return {
        value: item,
        label: item,
        active:
          activeBoolean ||
          isItemActive(item) ||
          Number(displayUserFiltering) === 1,
      }
    }

    if (
      item === StockOptions.ONLY_STOCKED &&
      Number(displayUserFiltering) === 2
    ) {
      return {
        value: item,
        label: item,
        active:
          activeBoolean ||
          isItemActive(item) ||
          Number(displayUserFiltering) === 2,
      }
    }

    if (item === StockOptions.SHOW_ALL && Number(displayUserFiltering) === 4) {
      return {
        value: item,
        label: item,
        active: activeBoolean || isItemActive(item),
      }
    }

    return {
      value: item,
      label: item,
      active: isItemActive(item),
    }
  })

export const getActiveStockOptionValue = (
  options: ListItem[]
): string | undefined =>
  options.find((option) => option.active)?.value?.toString()
